/**
 * Traditional Chinese (zh-TW) translations for watchout analysis.
 * Detailed palace/star interpretations fall back to zh-CN via the fallback chain.
 */
const watchout = {
  watchout: {
    title: "需要注意的方面",
    noData: "暫無可用的注意事項分析資料",
  },
};

export default watchout;
